import { render, staticRenderFns } from "./OnlCgformButtonModal.vue?vue&type=template&id=bec5d734&scoped=true&"
import script from "./OnlCgformButtonModal.vue?vue&type=script&lang=js&"
export * from "./OnlCgformButtonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec5d734",
  null
  
)

export default component.exports